<template>
  <div class="user-container">
    <van-row>
      <van-col span="24" class="profile-info">
        <div class="info">
          <div class="avatar-box">
            <img v-if="userInfo != null && userInfo.isLogin && userInfo.avatarUrl" mode="aspectFill" class="avatar"
              :src="userInfo.avatarUrl" />
            <img v-else class="avatar" src="../../../assets/images/default.jpeg" alt="" />
          </div>
          <div class="name-box">
            <div>
              <div v-if="userInfo != null && userInfo.isLogin">
                <div class="title_flex">
                  <div class="nameBoxLeft">
                    <div class="flex">
                      <div class="image_xs" v-if="userInfo.isSaleIdentity">
                        <img src="../../../assets/images/xs.png" alt />
                      </div>

                      <label class="nickName ellipsisTextName" v-if="
                        userInfo.userType == 'employee' ||
                        userInfo.userType == 'owner'
                      ">{{ userInfo.nickName }}</label>
                      <label class="nickName ellipsisTextName" v-else>{{
                        userInfo.nickName
                      }}</label>
                    </div>
                    <!-- 店长 店员 用户 及状态 -->
                    <div class="user-status">
                      <!-- @click="userClickReplay" -->
                      <div class="user_flex">
                        <div class="image_idCard">
                          <img src="../../../assets/images/id-card.png" alt />
                        </div>
                        <div>
                          <div v-if="userInfo.userType == 'employee'" class="userReplayEmployee">
                            <div>店员</div>

                            <!-- 店员 -->
                            <div class="flex_status" @click="onClickText(userInfo.statusName)"
                              v-if="userInfo.userType == 'employee'">
                              <span>{{
                                getChineseText(userInfo.statusName)
                              }}</span>
                              <div class="image_status" v-if="userInfo.statusName !== 'normal'">
                                <img src="../../../assets/images/status.png" alt />
                              </div>
                            </div>
                          </div>

                          <div v-if="userInfo.userType == 'owner'" class="userReplay">
                            店长
                          </div>
                          <div v-if="userInfo.userType == 'common'" class="userReplayEmployee">
                            <div>普通用户</div>

                            <!-- 用户 -->
                            <div class="flex_status" @click="onClickstatus(userInfo.statusName)"
                              v-if="userInfo.userType == 'common'">
                              <span>{{
                                getChineseStatus(userInfo.statusName)
                              }}</span>
                              <div class="image_status" v-if="userInfo.statusName !== 'normal'">
                                <img src="../../../assets/images/status.png" alt />
                              </div>
                            </div>
                          </div>

                          <!-- <van-cell
                        v-if="userInfo.userType == 'employee'"
                        value="店员"
                        class="userReplay"
                      /> 
                       -->
                        </div>
                      </div>
                    </div>
                    <!-- <svg t="1656913159240"
                         class="icon"
                         viewBox="0 0 1024 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         p-id="3283"
                         width="18"
                         height="17"
                         style="margin-left: 3px"
                         @click="GetAvatar">
                      <path d="M872.802928 755.99406 872.864326 755.99406 872.864326 755.624646Z"
                            p-id="3284"
                            fill="#bfbfbf"></path>
                      <path d="M922.268526 475.740168c-10.490935-10.727319-28.947286-10.815323-39.587624-0.366344l-18.368346 18.059308c-9.727549-206.461235-177.482227-367.192963-384.91458-367.192963-212.706473 0-385.751644 173.045171-385.751644 385.752668 0 212.720799 173.045171 385.766994 385.751644 385.766994 113.354698 0 220.62891-50.167586 293.924239-137.161916 3.2623-2.495844 5.907547-5.494131 7.907087-8.875135 0.26606-0.322341 0.557702-0.64673 0.853437-0.940418l1.880837-2.998287-0.618077-0.322341c1.26276-3.321652 1.851161-6.5246 1.851161-9.815553 0-16.077164-13.049201-29.155017-29.124318-29.155017-9.66922 0-18.721387 5.142114-23.982204 13.489222-62.806441 75.444273-154.911162 118.734218-252.691139 118.734218-181.244924 0-328.751443-147.447167-328.751443-328.721767 0-181.231621 147.506519-328.72279 328.751443-328.72279 180.070168 0 326.782601 145.509025 328.693114 325.122799l-32.709983-32.813337c-10.552334-10.623965-29.036313-10.653641-39.588647-0.086981-10.991332 10.933003-10.991332 28.712949-0.059352 39.660278l69.064982 69.226664c5.262864 5.320169 12.31549 8.229428 19.778462 8.229428l0.324388-0.028653 0.733711 0.23536c1.589195 0.38067 3.321652 0.851391 5.232165 0.851391 7.375991 0 14.34266-2.849908 19.633153-8.022721l71.445192-70.300113c5.348821-5.246491 8.346085-12.31549 8.405437-19.808138C930.410973 488.069985 927.529343 481.059314 922.268526 475.740168"
                            p-id="3285"
                            fill="#bfbfbf"></path>
                    </svg> -->
                  </div>
                  <!-- 消息 -->
                  <div class="flex flexAutoR">
                    <div class="myShareCode" @click="onClickShareCode" v-if="
                      userInfo.userType == 'owner' ||
                      userInfo.userType == 'employee'
                    ">
                      <svg class="iconShareSize" aria-hidden="true">
                        <use xlink:href="#icon-fenxiangma"></use>
                      </svg>
                      <div class="shareCodeSize">分享码</div>

                      <!-- <van-icon name="arrow" class="shareIcon" /> -->
                    </div>
                    <div class="myShareCode" @click="onClickCommonShareCode" v-if="
                      userInfo.userType == 'common' &&
                      userInfo.statusName == 'normal' &&
                      userInfo.isUserBindActivity == true
                    ">
                      <svg class="iconShareSize" aria-hidden="true">
                        <use xlink:href="#icon-fenxiangma"></use>
                      </svg>
                      <div class="shareCodeSize">分享码</div>

                      <!-- <van-icon name="arrow" class="shareIcon" /> -->
                    </div>

                    <div style="
                        position: relative;
                        margin-top: -6px;
                        margin-left: 20px;
                      ">
                      <div class="childMessage" @click="onClickMessage">
                        <img src="../../../assets/images/message.png" alt="" />
                      </div>
                      <van-badge dot v-if="!readStatus" style="position: absolute; top: -3px; right: 1px">
                      </van-badge>
                    </div>
                  </div>
                </div>
              </div>

              <label v-else>登录 / 注册</label>
            </div>
          </div>
        </div>
      </van-col>
    </van-row>
    <!-- 普通用户并且是同意状态 申请店员 -->
    <!-- <div
      class="flex-row"
      v-if="
        userInfo.userType == 'common' &&
        userInfo.statusName == 'normal' &&
        isTrue == false
      "
    >
      <div class="keepWidth"></div>
      <div style="flex: 1; margin: auto">
        <div
          v-if="isTrue == false && IsRegisterEmployee == true"
          @click="onclerkRegister"
        >
          <img src="../../../assets/images/nav.png" alt="" />
        </div>
      </div>
      <div class="keepWidth"></div>
    </div> -->
    <!-- <div
      class="flex-row"
      v-if="
        userInfo.userType !== 'owner' &&
        userInfo.statusName !== 'limited' &&
        (iscanApplyPartner || isCanBeSale)
      "
    >
      <div class="keepWidth"></div>
      <div
        style="flex: 1; margin: auto"
        v-if="iscanApplyPartner || isCanBeSale"
      >
        <div class="applyOwner">
          <div class="applyStyleOwner">
            <div class="applyAllTxt">
              <div class="applyTxt" v-if="iscanApplyPartner">
                您已满足成为店长条件
              </div>
              <div class="applyTxt" v-if="isCanBeSale">
                您已满足成为销售条件
              </div>
              <div class="applyTxt" v-if="iscanApplyPartner">
                可申请成为店长
              </div>
              <div class="applyTxt" v-if="isCanBeSale">可申请成为销售</div>
            </div>
            <button class="applyButton" @click="onSubmitApply">提交申请</button>
          </div>
        </div>
      </div>
      <div class="keepWidth"></div>
    </div> -->
    <!-- win 库存码 奖励库存码 利润 -->
    <!-- <div
      class="user-group"
      v-if="userInfo.userType == 'owner' || userInfo.userType == 'employee'"
    >
      <van-row class="userAround">
        <div class="aroundWidth" @click="onClickCode">
          <div class="aroundNumber">{{ userPCode }}</div>
          <div class="aroundText">库存码</div>
        </div>
        <div class="aroundWidth" @click="onClickCode">
          <div class="aroundNumber">{{ rewardPCode }}</div>
          <div class="aroundText">奖励库存码</div>
        </div>
        <div
          class="aroundWidth"
          v-if="userInfo.userType == 'owner'"
          @click="onBrokerage"
        >
          <div class="aroundNumber">{{ balance }}</div>
          <div class="aroundText">利润</div>
        </div>
      </van-row>
    </div> -->

    <!-- 新增手动领取优惠码 -->
    <!-- <div class="userClaimCode" v-if="userInfo.statusName !== 'limited'">
      <div class="flex">
        <div class="claimCodeText">优惠码</div>
        <div class="flex" style="font-weight: 500; color: #000000">
          <div class="flex" style="margin-right: 12px">
            可使用
            <div class="codeInfoNum">
              {{ codeInfo !== null ? codeInfo.usableNum : 0 }}
            </div>
          </div>
          <div class="flex">
            可领取
            <div class="codeInfoNum">
              {{ this.codeInfo !== null ? codeInfo.availableNum : 0 }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex"
        :class="
          codeInfo !== null && codeInfo.availableNum > 0
            ? 'userCodeRedButton'
            : 'userCodeButton'
        "
        @click="onAvailableNum"
      >
        <div>立即领取</div>
        <van-icon
          size="16px"
          name="arrow"
          :color="
            codeInfo !== null && codeInfo.availableNum > 0
              ? '#E54B43'
              : '#c1c1c1'
          "
          style="margin-bottom: 0"
        />
      </div>
    </div> -->
    <!--购买码不足，请手动领取购买码弹窗  -->
    <div class="claimCodeCard">
      <van-overlay :show="IsClaimCode">
        <div class="claimCode">
          <div class="claimCodeBox">
            <div class="claimCodeContent">赠送您</div>
            <div class="flexCenter" style="height: 17.1vw; font-size: 4.8vw">
              <div style="font-size: 11.73vw">
                {{ codeInfo !== null && codeInfo.availableNum }}
              </div>
              <div>个优惠码</div>
            </div>
            <div class="claimCodeTips">请在{{ year }}年1月1日之前使用</div>
            <div @click="onHandleClaimCode">
              <button class="ClaimCodeButton">立即领取</button>
            </div>
          </div>
          <van-icon name="close" class="claimCodeClose" @click="IsClaimCode = false" />
        </div>
      </van-overlay>
    </div>
    <!-- lhy修改 新增积分模块 -->
    <!-- <div class="user-group-integral">
      <van-cell value="积分中心"
                is-link
                @click="goIntegralShop()">
        <template #title>
          <span class="custom-title">我的积分</span>
          <img src="../../../assets/images/coin.png"
               alt=""
               class="integral-image" />
          <span class="user-group-integral-scope">{{ userScore }}</span>
        </template>
</van-cell>
</div> -->
    <!-- <div class="user-group-integral" @click="goIntegralShop()">
      <div class="user-group-integral-box">
        <div class="user-group-integral-box-left">
          <span>我的积分</span>
          <img
            src="../../../assets/images/coin.png"
            alt=""
            class="integral-image"
          />
          <span class="user-group-integral-scope">{{ userScore }}</span>
        </div>
        <div class="user-group-integral-box-right van-cell__value">
          <div>积分中心</div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
      </div>
    </div> -->
    <!-- ================== -->
    <!-- 订单 -->
    <div class="user-group">
      <div class="user-myOrder">
        <van-cell @click="onOrderClick('')" title="我的订单" is-link value="全部订单" class="user-Ordercell" />
      </div>
      <van-row class="user-lines">
        <!-- <van-col span="5" @click="onOrderClick('')">
          <van-icon size="28px" name="underway" color="#F93839" />全部订单
        </van-col> -->
        <van-col span="6" @click="onOrderClick('1')">
          <van-icon size="28px" name="todo-list" color="#F93839" v-bind:badge="unpaidOrderQuantity" />待付款
        </van-col>
        <van-col span="6" @click="onOrderClick('2')">
          <van-icon size="28px" name="shop-collect" color="#F93839" />待发货
        </van-col>
        <van-col span="6" @click="onOrderClick('3')">
          <van-icon size="28px" name="logistics" color="#F93839" />已发货
        </van-col>
        <van-col span="6" @click="onRefund('1,2')">
          <van-icon size="28px" name="smile-comment" color="#F93839" />
          退款/售后
        </van-col>
      </van-row>
    </div>
    <div class="user-group">
      <div class="user-myOrder">我的工具</div>
      <!-- 散户 -->
      <van-row class="user-links">
        <van-col span="6" @click="onClickAddress" class="cardHeight">
          <!-- <van-icon size="28px" name="map-marked" color="#47C75B" />地址管理 -->
          <svg class="userSuperiorIcon" aria-hidden="true">
            <use xlink:href="#icon-dizhiguanlitubiao"></use>
          </svg>
          <div>地址管理</div>
        </van-col>
        <van-col span="6" @click="onSetting" class="cardHeight">
          <svg class="userSuperiorIcon" aria-hidden="true">
            <use xlink:href="#icon-zhanghaoguanlitubiao"></use>
          </svg>
          <div>账号管理</div>
        </van-col>
        <!-- <meta name="format-detection" content="telephone=yes" /> -->
        <van-col span="6" @click="callPhone(phone)" class="cardHeight">
          <svg class="userSuperiorIcon" aria-hidden="true">
            <use xlink:href="#icon-wodekefutubiao"></use>
          </svg>
          <div>我的客服</div>
        </van-col>
        <!-- <van-col span="6" @click="goIntegralShop()" class="cardHeight">
          <svg class="userSuperiorIcon" aria-hidden="true">
            <use xlink:href="#icon-jifenzhongxintubiao"></use>
          </svg>
          <div>积分中心</div>
        </van-col> -->
        <van-col span="6" class="colHeight iconBlock" @click="tihuomaClick">
          <!-- <div class="iconMark">
            {{ pickUpCount }}
          </div> -->
          <svg class="userSuperiorIcon" aria-hidden="true">
            <use xlink:href="#icon-tihuoma"></use>
          </svg>
          <div>提货码</div>
          <div class="red">
            剩余: {{ pickUpCount }}
          </div>
        </van-col>
      </van-row>
    </div>
    <p class="edition">v1.4.9.1.0Copyright © 2021{{ title }} 版权所有</p>
    <!-- loading -->
    <van-overlay :show="isLoading" style="z-index: 2100">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!--  -->
    <div class="wrapper">
      <employeeToast v-if="IsEmployeeToast == true"></employeeToast>
    </div>
    <!--上传二维码名片  -->
    <div class="businessCard" style="position: relative">
      <van-popup v-model="IsShowSuperiorCard" class="popupBorder">
        <MyBusinessCard v-if="IsShowSuperiorCard"></MyBusinessCard>
        <van-icon name="cross" @click="onClose" color="#999" size="18px"
          style="position: absolute; z-index: 10; top: 16px; right: 16px" />
      </van-popup>
    </div>
    <!-- 我的服务人弹窗 -->
    <div class="businessCard" style="position: relative">
      <van-popup v-model="IsSuperior" class="popupBorder">
        <superior v-if="IsSuperior" :msgSuperior="msgSuperior"></superior>
        <van-icon name="cross" @click="onSuperiorClose" color="#999" size="18px"
          style="position: absolute; z-index: 10; top: 16px; right: 16px" />
      </van-popup>
    </div>
    <!-- 客服电话弹窗 -->
    <van-dialog v-model="close" show-cancel-button @confirm="onConfirm" @cancel="onCancel">
      <div class="phoneContent">
        <div style="padding-bottom: 8px">是否拨打4008658777?</div>
        <span style="font-size: 12px; color: #999">工作时间：9:00-12:00 13:00-18:00</span>
      </div>
    </van-dialog>
    <div class="businessCard" style="position: relative">
      <van-popup v-model="IsTihuo" class="popupTihuo">
        <div class="tihuoTitle">提货码</div>
        <van-icon name="close" class="tihuoClose" @click="IsTihuo = false" />
        <div v-for="item in tihuoList" :key="item.queueCode" class="TihuoBox" v-if="tihuoList.length > 0">
          <div class="ellipsisText queueCode">{{ item.queueCode }}</div>
          <div @click="copy" :data-clipboard-text="item.queueCode" class="code">复制</div>
        </div>
        <div v-if="tihuoList.length == 0" class="noList">
          <div class="imageEmpty">
            <img src="../../../assets/images/orderEmpty.png" alt />
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Button,
  Toast,
  Popup,
  Overlay,
  Badge,
  form,
  field,
} from "vant";

import loading from "../../components/loading/loading";
import employeeToast from "../../components/employeeToast/index";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/userCenterPage/userCenterPage.js";
import serviceUser from "../../api/user/index";
import serviceBank from "../../api/bank/index";
// import serviceStatus from "../../api/redirect";
import { wxPay } from "../../util/wxHelper";
import servicePay from "../../api/payment/wxpay/index";
import MyBusinessCard from "../../components/MyBusinessCard/index";
import superior from "../../components/superior/index";
import serviceSuperior from "../../api/superior/index";
import serviceCustomer from "../../api/myShare/index";
import serviceMaintenance from "../../api/maintenance/index";
// import shareCodeResult from "../shareCodeResult/index.vue";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.Component.name]: Dialog.Component,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    [Badge.name]: Badge,
    [form.name]: form,
    [field.name]: field,
    loading,
    employeeToast,
    MyBusinessCard,
    superior,
  },
  data() {
    return {
      // lhy 新增
      userScore: null, //用户积分
      scoreShop: "", //积分商城跳转链接
      invitatCode: "", //雇佣数量
      // ========
      msgSuperior: "", //服务人传值
      year: "2023",
      IsClaimCode: false, //是否显示购买码弹窗
      msgSuperior: "", //服务人传值
      close: false, //关闭弹窗
      IsSuperior: false, //是否显示我的上级
      IsShowSuperiorCard: false, //是否显示二维码名片
      partnerListShow: false, //判断店长是否为法人
      // IsShowEmployee: false, //申请店员弹窗展示
      normalPcode: {}, //绑定用户剩余码数(可用，可领取)
      IsRegisterEmployee: false, //是否展示申请店员按钮
      rejectReasons:
        "您的账户信息未绑定，请前去修改您的信息，否则工资将不能够准时发放！",
      title: "",
      // IsCodeResult: false, //绑定结果
      IsEmployeeToast: false,
      isLoading: true, //loading状态
      isRed: false,
      isTrue: false,
      goodsId: "",
      orderNo: "",
      readStatus: true, // readStatus true是已读
      guaranteenum: 0, // 担保人数
      balance: 0,
      // UserStock: 0,
      EmployeeStock: 0, //店长店员库存余量
      phone: 4008658777,
      userStatus: false,
      toolList: [
        {
          id: 0,
          toolText: "地址管理",
          img: "location-o",
        },
        {
          id: 4,
          toolText: "账号管理",
          img: "setting-o",
        },
        {
          id: 5,
          toolText: "我的客服",
          img: "phone-circle-o",
        },
      ],
      mybrokerage: 0,
      //待付款数量
      unpaidOrderQuantity: 0,
      CodeNum: 0,
      // lhy 新增贷款申请数量 代理申请数量
      loanApplication: "0",
      agencyApplication: "0",
      maintenance: "0",
      userPCode: 0, //用户库存码
      rewardPCode: 0, //用户库存码
      salesApprovalQuantity: 0, //销售审批待确认数量(我的业绩)
      partnerApprovalQuantity: 0,
      iscanApplyPartner: false, //能否申请店长
      isCanBeSale: false, //能否申请销售
      closeApply: false,
      ydCode: "",
      pickUpCount: 0,//提货码数量
      IsTihuo: false,
      tihuoList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankCardStatus", "agentShow", "codeInfo"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
  methods: {
    ...mapActions(["login", "wxLogin", "saveBankStatus", "updatePcode", "buyAgentStatus"]),
    // lhy  去贷款申请页面
    goLoanAppilcation() {
      this.$router.push({ name: "shopkeeper" });
    },
    // lhy 去审核页面
    goAgencyApplication() {
      this.$router.push({ name: "application" });
    },
    // 用户状态
    getChineseStatus(StatusText) {
      switch (StatusText) {
        case "frozen":
          return "冻结";
        case "limited":
          return "未认证";
        case "normal":
          return "";
        default:
          "状态异常";
          break;
      }
    },
    // 关闭二维码名片
    onClose() {
      this.IsShowSuperiorCard = false;
    },
    // 关闭我的服务人
    onSuperiorClose() {
      this.IsSuperior = false;
    },
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    onClickstatus(status) {
      if (status == "frozen") {
        Toast("账号冻结，请联系客服人员");
      } else if (status == "limited") {
        Toast("您的账号未认证");
      } else if (status == "normal") {
        // Toast("账号已冻结");
      } else {
        Toast("账号异常，请联系客服人员");
      }
    },
    partner() {
      this.$router.push({ name: "partnerList" });
    },
    goShopping(num) {
      this.$router.push({ name: "codeShowPage", query: { CodeNum: num } });
    },
    // 店长我的分享
    onShare() {
      this.$router.push("myShareCode");
    },
    // 我的店员我的分享
    onEmpShare() {
      this.$router.push("myEmpShareCode");
    },
    // 跳到分享二维码
    onClickShareCode() {
      this.$router.push("shareCode");
    },
    // 绑定用户跳转分享二维码
    onClickCommonShareCode() {
      this.$router.push("commonShareCode");
    },
    // 消息是否已读
    chatStatus() {
      serviceUser.getChatStatus().then((res) => {
        if (res.statusCode == 200) {
          this.readStatus = res.data;
        }
      });
    },
    // 获取库存码和奖励库存码
    getUserCode() {
      serviceUser.getCode().then((res) => {
        if (res.statusCode == 200) {
          this.userPCode = res.data.normal;
          this.rewardPCode = res.data.reward;
        }
      });
    },

    getSalesQuantity() {
      // 获取销售审批待确认数量
      serviceUser.GetSalesApprovalQuantity().then((res) => {
        if (res.statusCode == 200) {
          this.salesApprovalQuantity = res.data;
        }
      });
      // 获取销售店长申请待确认数量
      serviceUser.GetPartnerApprovalQuantity().then((res) => {
        if (res.statusCode == 200) {
          this.partnerApprovalQuantity = res.data;
        }
      });
    },

    // =========lhy 新增 ==========
    // 获取积分
    async getScore() {
      await serviceUser.getUserScore().then((res) => {
        if (res.statusCode == 200) {
          this.userScore = res.data;
        }
      });
    },
    // 获取积分商城跳转链接
    async getIntegral() {
      await serviceUser.getIntegralLogin().then((res) => {
        console.log(res.statusCode, 960);
        if (res.statusCode == 200) {
          this.scoreShop = res.data;
          window.location.href = this.scoreShop;
        }
      });
    },
    // 获取雇佣邀请
    async invitationQuantity() {
      await serviceUser.getInvitationQuantity().then((res) => {
        if (res.statusCode == 200) {
          this.invitatCode = res.data;
        }
      });
    },
    // 前往商城
    goIntegralShop() {
      this.getIntegral();
      //调取接口 跳转到积分商城项目
      // console.log(this.scoreShop);
    },
    // 提货码
    // 是否有桃花恋提货码
    getIsPickUp() {
      this.isLoading = true
      console.log('getIsPickUp')
      serviceUser.CheckUserIsPickUp()
        .then((res) => {
          if (res.statusCode == 200) {
            this.pickUpCount = res.data.count
          }
        })
      this.isLoading = false
    },
    // 我的雇佣
    goHire() {
      this.$router.push("hire");
    },
    // 雇佣邀请
    goHireInvite() {
      this.$router.push("hireInvite");
    },
    // 我的核销码
    goOrderCode() {
      this.$router.push("orderCode");
    },
    revokeChange() {
      // 撤销店员申请
      serviceUser.isCanRevocation().then((res) => {
        if (res.data == false || res.statusCode == 500) {
          this.isTrue = false;
        } else {
          this.isTrue = true;
        }
      });
    },
    // 点击是否能够撤销申请
    IsRevoke() {
      if (this.isTrue) {
        Dialog.confirm({
          message: "是否撤销店员申请?",
        })
          .then(() => {
            serviceUser.revocationApply().then((res) => {
              if (res.statusCode == 200 && res.data) {
                Toast("撤销成功");
                this.init();
              } else {
                Toast(res.errors);
              }
            });
          })
          .catch(() => { });
      } else {
        this.isTrue = false;
        Toast("不符合撤销条件");
      }
    },
    // 判断店长是否为法人
    getpartnerList() {
      serviceUser.getpartner().then((res) => {
        if (res.statusCode == 200 && res.data) {
          this.partnerListShow = true;
        } else {
          this.partnerListShow = false;
        }
      });
    },
    changeColor() {
      // 是否能购买
      serviceUser.employeenBuy(this.userInfo.userId).then((res) => {
        if (res.data == false || res.statusCode == 500) {
          this.isRed = false;
        } else {
          this.isRed = true;
          this.goodsId = res.data.id;
        }
      });
    },
    // 点击是否能够购买
    onShow() {
      if (this.AgentIsShow == true) {
        Toast("代买中，不可购买库存");
        return;
      }
      if (this.isRed) {
        this.$router.push({ name: "goods", query: { code: this.goodsId } });
      } else {
        this.isRed = false;
        Toast("不符合购买条件");
      }
    },
    // // 店员店长购买库存
    // confirm() {
    //   this.show = false;
    //   serviceUser.post({ orderType: 4 }).then((res) => {
    //     if (res.statusCode == 200) {
    //       this.orderNo = res.data;
    //       this.pay();
    //     }
    //   });
    //   this.isRed = true;
    // },
    // 支付
    pay() {
      servicePay
        .unifiedOrder(this.orderNo, this.userInfo.openId)
        .then((res) => {
          wxPay(res.data)
            .then(() => {
              this.$router.replace({
                name: "payResult",
                query: { id: this.orderNo, status: true },
              });
            })
            .catch((err) => {
              this.$router.replace({
                name: "payResult",
                query: { id: this.orderNo, status: false },
              });
            });
        })
        .catch((err) => {
          this.$router.replace({
            name: "payResult",
            query: { id: this.orderNo, status: false },
          });
        });
    },
    // 申请店员
    onclerkRegister() {
      this.$router.push("userMessage");
    },
    apply() {
      this.$router.push("applyList");
    },
    onShowStock() {
      // 店员店长库存余量
      serviceUser.employeeStock().then((res) => {
        this.EmployeeStock = res.data;
      });
    },
    // 获取头像
    GetAvatar() {
      let redirectUrl = this.$route.query.redirect || "/user";
      var redirect = "https://" + window.location.host + "/getAvatar";
      // "https://testygw.m.taohuasanbao.com/redirect"
      var redirect_uri = encodeURIComponent(redirect);
      console.log(
        webconfig.path,
        webconfig.path + "/redirect",
        redirect_uri,
        redirectUrl,
        110
      );
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${webconfig.appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${redirectUrl}#wechat_redirect`;
    },

    // 刷新
    // userClickReplay() {
    //   let openId = this.userInfo.openId;
    //   serviceStatus.wxLoginTest(openId).then((res) => {
    //     if (res.statusCode == 200) {
    //       this.wxLogin(res.data);
    //       // Toast("成功刷新");
    //       this.init();
    //     } else {
    //       Toast("请重新登录");
    //       this.$router.replace("login");
    //     }
    //   });
    // },
    // 店员
    getChineseText(StatusText) {
      switch (StatusText) {
        case "frozen":
          return "冻结";
        case "unreviewed":
          return "已注册,未担保";
        case "reviewfailed":
          return "担保失败";
        case "reviewed":
          return "担保成功";
        case "disAgreed":
          return "审核失败";
        case "agreed":
          return "账号可用";
        default:
          "状态异常";
          break;
      }
    },
    // 点击提示
    onClickText(status) {
      if (status == "frozen") {
        Toast("账号冻结,请联系客服人员");
      } else if (status == "unreviewed") {
        Toast("已注册,未担保");
      } else if (status == "reviewfailed") {
        Toast("担保失败");
      } else if (status == "reviewed") {
        Toast("担保成功");
      } else if (status == "disAgreed") {
        Toast("审核失败");
      } else if (status == "agreed") {
        Toast("店长已同意");
      } else {
        Toast("账号异常，请联系客服人员");
      }
    },

    onOrderClick(orderStatusId) {
      this.$router.push({
        name: "myorder",
        query: { orderStatusId: orderStatusId },
      });
    },
    onRefund(orderStatusId) {
      this.$router.push({
        name: "refundlist",
        query: { orderStatusId: orderStatusId },
      });
    },
    myClerk() {
      this.$router.push("clerk");
    },
    onInvitation() {
      this.$router.push("invitation");
    },
    // 跳转到库存码
    onSalesPerformance() {
      this.$router.push({
        name: "salesPerformance",
        query: {
          status: 0,
        },
      });
    },
    // 跳转到库存码
    onClickCode() {
      this.$router.push({
        name: "inventoryCode",
      });
    },
    // 利润列表 没定下来
    onBrokerage() {
      this.$router.push({
        name: "profit",
      });
    },
    onClickAddress() {
      this.$router.push("myAddress");
    },
    // 优惠卷摸块
    coupons() {
      this.$router.push({ name: "coupons" });
    },
    // 消息列表
    onClickMessage() {
      this.$router.push("chatlist");
    },
    // 设置
    onSetting() {
      this.$router.push("setting");
    },
    // 我的服务人 显示二维码
    onSuperior() {
      this.isLoading = true;
      serviceSuperior.get().then((res) => {
        if (res.statusCode == 200) {
          if (res.data == "您的服务人未上传二维码名片") {
            this.isLoading = false;
            Toast(res.data);
            this.IsSuperior = false;
          } else {
            this.isLoading = false;
            this.IsSuperior = true;

            this.msgSuperior = res.data;
            // this.msgSuperior = 'https://img01.yzcdn.cn/vant/tree.jpg'
          }
        } else {
          this.isLoading = false;
          this.IsSuperior = false;
          Toast(res.errors);
        }
      });
    },
    // 上传二维码名片
    onClickSuperiorCard() {
      this.IsShowSuperiorCard = true;
    },
    onLike() {
      this.$router.push("like");
    },
    // 电话
    callPhone(phoneNumber) {
      // Dialog.confirm({
      //   message: "是否拨打4008658777?"
      // })
      //   .then(() => {
      //     window.location.href = "tel://" + phoneNumber;
      //   })
      //   .catch(() => { });
      this.close = true;
    },
    // 确定
    onConfirm() {
      this.close = false;
      window.location.href = "tel://" + this.phone;
    },
    // 取消
    onCancel() {
      this.close = false;
    },
    getGuaranteenum() {
      // 担保申请数量
      serviceUser.getGuaranteenum(this.userInfo.phoneNumber).then((res) => {
        this.guaranteenum = res.data;
      });
    },
    // 跳转到银行卡页面
    onBinding() {
      this.$router.push("addBankCard");
    },
    // 跳转到代买人列表
    onbuyAgent() {
      this.$router.push("AgentNickName");
    },
    // 跳转到我的统计
    onMyStatistics() {
      this.$router.push("myStatistics");
    },
    // 跳转到我的资产
    onClickMyproperty() {
      this.$router.push("myProperty");
    },
    // 客情维护
    onMaintenance() {
      // 跳转到客情维护
      this.$router.push("maintenance");
    },
    // onMaintenance () {
    //   var share = {
    //     month: 0,
    //     activeType: 1,
    //   };
    //   serviceCustomer
    //     .list(share.activeType, share.month, 1, 20)
    //     .then((res) => {
    //       if (res.statusCode == 200) {
    //         if (res.data.items.length == 0) {
    //           this.IsDetailShow = false;
    //           Toast("暂无维护");
    //         } else {
    //           // 跳转到客情维护
    //           this.$router.push("CustomerMaintenance");
    //         }
    //       } else {
    //         Toast(res.errors);
    //       }
    //     })
    //     .catch((error) => {
    //       Toast(error);
    //     });
    // },
    getBankStatus() {
      serviceBank.getStatus().then((res) => {
        if (res.statusCode == 200) {
          let obj = {
            save: true,
            cardStatus: false,
            color:
              this.bankCardStatus !== null && this.bankCardStatus.color
                ? this.bankCardStatus.color
                : 0,
          };
          this.saveBankStatus(obj);
          if (res.data == "未绑定") {
            Dialog.confirm({
              title: "提示",
              message: this.rejectReasons,
            })
              .then(() => {
                // 每次登录过后提示一次，存起来，如果true 则不提示 否则再次提示。
                // this.saveBankStatus(true);

                // on confirm
                this.$router.push("addBankCard");
                // this.$router.push({
                //   name: "addBankCard",
                //   query: {
                //     IsBankCardShow: true
                //   }
                // });
              })
              .catch((err) => {
                Toast("已取消");
              });
          }
          if (res.data == "通过") {
            let obj = {
              save: true,
              cardStatus: true,
              color:
                this.bankCardStatus !== null && this.bankCardStatus.color
                  ? this.bankCardStatus.color
                  : 0,
            };
            this.saveBankStatus(obj);
          }
          if (res.data == "未通过") {
            // this.IsEmployeeToast = true;
            let obj = {
              save: true,
              cardStatus: true,
              IsShow: true,
              color:
                this.bankCardStatus !== null && this.bankCardStatus.color
                  ? this.bankCardStatus.color
                  : 0,
            };
            this.saveBankStatus(obj);
            Dialog.confirm({
              title: "提示",
              message: "账号信息有误",
            })
              .then(() => {
                // on confirm
                this.$router.push({
                  name: "detailBankCard",
                });
              })
              .catch((err) => {
                Toast("已取消");
              });
          }
        } else {
          // this.saveBankStatus(false);
        }
      });
    },
    // 绑定用户是否展示申请店员按钮
    onRegisterEmployee() {
      serviceUser
        .isCanRegister()
        .then((res) => {
          if (res.statusCode == 200 && res.data) {
            this.IsRegisterEmployee = true;
          } else {
            this.IsRegisterEmployee = false;
          }
        })
        .catch((err) => {
          this.IsRegisterEmployee = false;
        });
    },
    // 如果可领取数量大于0则可以领取
    onAvailableNum() {
      if (this.codeInfo !== null && this.codeInfo.availableNum > 0) {
        this.IsClaimCode = true;
      }
    },
    // 立即领取
    onHandleClaimCode() {
      this.isLoading = true;
      serviceUser
        .ManualClaim()
        .then((res) => {
          if (res.statusCode == 200) {
            this.IsClaimCode = false;
            Toast("领取成功");
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
            this.getPCodeByUser();
          } else {
            this.isLoading = false;
            Toast(res.errors);
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getPCodeByUser() {
      serviceUser
        .GetPCodeByPage()
        .then((res) => {
          if (res.statusCode == 200) {
            let codeNum = {
              available: res.data.available,
              usable: res.data.usable,
            };
            this.updatePcode(codeNum);
          }
        })
        .catch((err) => {
          Toast(err);
        });
    },
    // 清除缓存
    onClear() {
      localStorage.removeItem("__cartinfo__");
      localStorage.removeItem("__userinfo__");
      this.buyAgentStatus({ show: false });
      Toast("请重新登录");
      this.$router.replace("login");
    },
    onSubmitApply() {
      // this.closeApply = true;
      this.isLoading = true;
      // 销售
      if (this.isCanBeSale) {
        serviceUser
          .CheckUserCanBeSale()
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("申请成功");
              this.onApplyCancel();
              this.getcanApplyPartner();
              this.onClear()
            }
          })
          .catch((err) => {
            Toast(err);
          });
      } else {
        serviceUser
          .applyUpgradePartner({ ydCode: "" })
          .then((res) => {
            Toast("申请成功");
            if (res.statusCode == 200) {
              this.onApplyCancel();
              this.getcanApplyPartner();
            }
          })
          .catch((err) => {
            Toast(err);
          });
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
      console.log("onSubmitApply");
    },
    // 申请成为店长
    onApplyConfirm(values) {
      //   this.isLoading = true;
      //   // 销售
      //   if (this.isCanBeSale) {
      //     serviceUser
      //       .CheckUserCanBeSale(values)
      //       .then((res) => {
      //         if (res.statusCode == 200) {
      //           Toast("申请成功");
      //           this.onApplyCancel();
      //           this.getcanApplyPartner();
      //         }
      //       })
      //       .catch((err) => {
      //         Toast(err);
      //       });
      //   } else {
      //     serviceUser
      //       .applyUpgradePartner(values)
      //       .then((res) => {
      //         Toast("申请成功");
      //         if (res.statusCode == 200) {
      //           this.onApplyCancel();
      //           this.getcanApplyPartner();
      //         }
      //       })
      //       .catch((err) => {
      //         Toast(err);
      //       });
      //   }
      //   setTimeout(() => {
      //     this.isLoading = false;
      //   }, 500);
      //   console.log("submit", values);
    },
    onApplyCancel(values) {
      this.closeApply = false;
      this.ydCode = "";
    },
    copy() {
      var clipboard = new Clipboard(".code");
      clipboard.on("success", (e) => {
        Toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Toast("手机权限不支持复制功能");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 提货码
    tihuomaClick() {
      this.IsTihuo = true
      this.isLoading = true
      serviceUser.SelectUserPickUp().then((res) => {
        this.tihuoList = res.data;
      });
      this.isLoading = false
    },


    init() {
      localStorage.removeItem("getParamsAddress");
      var userInfo = this.userInfo;
      this.isLoading = true;
      if (userInfo.userType == "employee" && userInfo.statusName == "agreed") {
        this.userStatus = true;

        // 获取用户库存码
        // this.getUserCode();
        // 担保申请数量
        // this.getGuaranteenum();
        // 获取码数
        // this.getPCodeByUser();
        // 显示库存
        // this.onShowStock();
        // 能否购买显示对应的颜色
        // this.changeColor();
        // this.getcanApplyPartner();
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      } else if (userInfo.userType == "owner") {
        this.userStatus = true;
        // 只有店长才能显示  如果银行卡没有绑定并且没有问题则不提示
        // console.log(
        //   this.bankCardStatus == null,
        //   this.bankCardStatus,
        //   "this.bankCardStatus"
        // );

        // this.getcanApplyPartner();
        // 获取用户库存码
        // this.getUserCode();
        // if (this.bankCardStatus == null || !this.bankCardStatus.saveStatus) {
        //   this.getBankStatus();
        // }
        // this.getpartnerList();
        // 余额
        // serviceUser.ownerBalance().then((res) => {
        //   this.balance = res.data;
        // });
        // 显示库存
        // this.onShowStock();
        // 担保申请数量
        // this.getGuaranteenum();
        // 获取码数
        // this.getPCodeByUser();
        // this.changeColor();
        // 我的业绩数量
        // this.getSalesQuantity();
        // setTimeout(() => {
        //   this.isLoading = false;
        // }, 1200);
      } else {
        // if (userInfo.statusName == "normal") {
        // 用户优惠码数量
        // serviceUser.employeeCode().then((res) => {
        //   this.CodeNum = res.data;
        // });
        // this.revokeChange();
        // 能否申请店员
        // this.onRegisterEmployee();
        // 能否申请合伙达人;
        // this.getcanApplyPartner();
        // 获取码数
        // this.getPCodeByUser();
        // 用户库存
        // serviceUser.userStock().then((res) => {
        //   console.log(res.data);
        //   this.UserStock = res.data;
        // });
        //   setTimeout(() => {
        //     this.isLoading = false;
        //   }, 2000);
        // }
        this.userStatus = false;
      }
      setTimeout(() => {
        this.isLoading = false;
      }, 1200);
    },
  },
  mounted() {
    var date = new Date();
    this.year = date.getFullYear() + 1;
    this.partnerListShow = false;
    this.title = webconfig.title;
    if (this.userInfo.statusName == "frozen") {
      this.$router.replace("frozen");
      return;
    }
    // 未支付订单数量
    service.getUnPaidOrder().then((res) => {
      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 500);
      this.unpaidOrderQuantity = res.data;
    });
    // let IsCode = this.$route.params.IsCode;
    // if (IsCode) {
    //   this.$refs.IsCodeResult.$el.style.display = "block";
    // } else {
    //   this.$refs.IsCodeResult.$el.style.display = "none";
    // }
    // 提货码
    this.getIsPickUp()
    //获取申请数量（申请店长）
    // this.getKeeperCount();
    //获取申请数量（申请审核）
    // this.applyCount();
    // 获取客情维护数量
    // this.getMaintenanceCount();
    this.chatStatus();
    // lhy 新增 获取用户积分接口
    // this.getScore();
    // this.getIntegral();
    // 雇佣邀请
    // this.invitationQuantity();
    this.init();
    this.$log.debug("userInfo", this.userInfo, 211);
  },
};
</script>

<style lang="less" scoped>
@deep: ~">>>";

.popupTihuo {
  width: 76%;
  border-radius: 8px;
  padding: 16px;
  height: 400px;

  .TihuoBox {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
  }

  .tihuoTitle {
    // position: absolute;
    font-size: 18px;
    text-align: center;
    margin-bottom: 12px;
  }

  .tihuoClose {
    position: absolute;
    z-index: 16;
    top: 20px;
    font-size: 20px;
    right: 0;
    margin-right: 18px;
    color: #c1c1c1;
  }

  .code {
    color: #ee0a24;
  }

  .noList {
    width: 100%;
    text-align: center;
    font-size: 4vw;
    color: #92909a;
    padding-top: 72px;

    .imageEmpty {
      height: 209px;
      margin: auto;
    }
  }

  .queueCode {
    width: 200px;
  }
}



// lhy 新增css
.user-group-integral {
  color: #323233;
  overflow: hidden;
  height: 46px;
  line-height: 46px;
  margin: 0 13px;
  margin-bottom: 10px;
  overflow: hidden;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 0 7px;
  margin: 10px 10px 11px;
  border-radius: 10px;
  background-color: #fff;

  .van-cell {
    height: 46px;
  }

  .user-group-integral-box {
    height: 26px;
    line-height: 26px;
    padding: 10px 16px;

    .user-group-integral-box-left {
      float: left;
    }

    .user-group-integral-box-right {
      float: right;
      color: #969799;
      text-align: right;
      height: 26px !important;
      line-height: 26px;

      div {
        font-weight: 600;
        font-size: 3.4vw;
        height: 6.4vw !important;
        line-height: 6.4vw;
        display: inline-block;
        vertical-align: top;
      }

      i {
        display: inline-block;
        // display: flex;
        // align-self: center;
      }
    }

    span {
      height: 26px;
      line-height: 26px;
    }
  }
}

.shareCodeSize {
  font-size: 10px;
  font-weight: 600;
  color: rgba(242, 176, 84, 1);
  margin-top: 2px;
  text-align: center;
}

.custom-title {
  display: inline-block;
  vertical-align: middle;
}

.integral-image {
  margin-left: 12px;
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: middle;
}

.user-group-integral-scope {
  margin-left: 4px;
  font-size: 16px;
  // height: 16px;
  font-weight: 600;
  color: #f59e08;
  display: inline-block;
  vertical-align: middle;
}

// ==========
// lhy 新增 贷款申请记录和代理申请记录

.iconBlock {
  position: relative;
  color: rgba(51, 51, 51, 1);
}

.iconMark {
  position: absolute;
  top: -3px;
  right: 0;
  box-sizing: border-box;
  min-width: 4.26667vw;
  padding: 0 0.8vw;
  color: #fff;
  font-weight: 500;
  font-size: 3.2vw;
  font-family: -apple-system-font, Helvetica Neue, Arial, sans-serif;
  line-height: 1.2;
  text-align: center;
  background-color: #ee0a24;
  border: 1px solid #fff;
  border-radius: 4.26667vw;
  -webkit-transform: translate(50%, -50%);
  transform: translate(50%, -50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
  right: 18px;
}

.user {
  &-container {
    background: #f7f7f7;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    // height: calc(100% - 14vw);
    padding-bottom: 16.6vw;
    min-height: 100vh;

    .claimCodeText {
      font-weight: bold;
      width: 56px;
      margin-right: 12px;
    }

    // 库存 利润
    .userAround {
      display: flex;
      justify-content: space-around;
      margin-top: 11px;
    }

    .aroundWidth {
      text-align: center;
      margin: 16px 24px;
      padding: 0;
      flex: 1;

      .aroundNumber {
        margin-bottom: 8px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }

      .aroundText {
        height: 12px;
        font-size: 12px;
      }
    }

    // 分享码
    .myShareCode {
      color: #959798;
      font-size: 12px;
      // display: flex;
      align-items: center;

      .shareIcon {
        font-size: 10px;
        margin-bottom: 0;
        margin-top: 1px;
        margin-left: 4px;
      }
    }

    //
    .userCodeRedButton {
      color: #e24f45;
      font-weight: 500;
      font-size: 13px;
    }

    .userCodeButton {
      color: #c1c1c1;
      font-weight: 500;
      font-size: 13px;
    }

    .userClaimCode {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // justify-content: space-around;
      margin: 10px 10px 0;
      height: 26px;
      line-height: 26px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      padding: 10px 22px;
    }

    .codeInfoNum {
      color: #e64c44;
      font-weight: bold;
      margin-left: 4px;
    }

    //服务人icon
    .userSuperiorIcon {
      width: 6.5vw;
      height: 6.4vw;
      margin-bottom: 2.66667vw;
    }

    .userHeightIcon {
      width: 6.4vw;
      height: 7vw;
      padding: 0 3vw;
    }

    // 我的分享文字居中
    .userHeightCenter {
      height: 7vw;
      line-height: 7vw;
    }

    .colHeight {
      // margin-top: 12px;
      height: 76px;
    }

    .cardHeight {
      height: 76px;
    }

    .edition {
      text-align: center;
      margin: 36px 0;
      color: #929292;
      font-size: 12px;
    }

    .flex-row {
      margin-bottom: 2.9vw;
    }

    .button {
      text-align: center;
      font-size: 2.8vw;
      height: 5vw;
      line-height: 5vw;
    }

    .childMessage {
      width: 14px;
      height: 17px;
      margin-right: 2vw;
    }

    .pop {
      width: 45vw;
      height: 25vw;
      padding: 8vw;
      font-size: 4.8vw;
    }

    .red {
      color: #ee0a24;
    }

    .popButton {
      height: 7vw;
      line-height: 7vw;
      margin-top: 3vw;
      border-radius: 7vw;
    }

    .van-cell-group {
      margin: 7px;
      border-radius: 20px;
    }

    .van-col--12 {
      display: flex;
    }

    .manganerPic {
      width: 32px;
      height: 32px;
      padding: 0 3vw;
    }

    .bold {
      font-weight: bold;
      margin-bottom: 1vw;
    }

    .gray {
      color: #a6a6a6;
      padding-top: 0.09vw;
    }

    .flex_status {
      display: flex;
      align-items: center;
      font-size: 2.5vw;
      padding-left: 6px;
    }

    .userReplayEmployee {
      display: flex;
      align-items: center;
      padding-right: 4.5px;
      background-color: RGBA(255, 255, 255, 0.2);

      .van-icon {
        margin: 0;
      }
    }

    .userReplay {
      padding-right: 4.5px;
      background-color: RGBA(255, 255, 255, 0.2);

      .van-icon {
        margin: 0;
      }
    }

    .user_flex {
      display: flex;
      align-items: center;

      .van-icon {
        margin-bottom: 0;
        font-size: 3.6vw;
        color: #a3a3a3;
        // margin-left: 1vw;
        font-weight: bold;
      }
    }
  }
}

.applyContent {
  padding: 0 0 16px;
  position: relative;

  .applyContentIcon {
    position: absolute;
    right: 16px;
    top: 16px;
  }

  .applyContentTitle {
    font-size: 16px;
    font-weight: 600;
    line-height: 48px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    border-bottom: 0.5px solid rgba(230, 230, 230, 1);
  }

  .applyNo {
    line-height: 14px;
    color: rgba(237, 0, 0, 1);
  }

  .applyNoTxt {
    font-size: 14px;
    font-weight: 400;
    padding: 20px 0 2px 16px;
  }

  .inputApply {
    .van-cell {
      @{deep}.van-field__body {
        height: 24px;
        border-radius: 8px;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        padding: 8px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;

      }

      @{deep}.van-field__error-message {
        padding-left: 16px;
      }
    }
  }
}

.applyOwner {
  height: 62px;
  border-radius: 8px;
  background-image: url(../../../assets/images/applyOwner.jpg);
  background-repeat: no-repeat;
  background-size: 100vw 62px;
  margin: auto;
  position: relative;

  img {
    border-radius: 8px;
  }

  .applyStyleOwner {
    display: flex;
    justify-content: space-between;
    padding: 15px 15px 7px 120px;
  }

  .applyAllTxt {
    padding-right: 12px;
  }

  .applyTxt {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 12px;
    color: rgba(248, 217, 173, 1);
    margin-bottom: 8px;
  }

  .applyButton {
    // width: 68px;
    padding: 8px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    background: linear-gradient(90deg,
        rgba(248, 217, 173, 1) 0%,
        rgba(255, 234, 204, 1) 100%);
    border: none;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 12px;
    color: rgba(51, 51, 51, 1);
  }
}

.Stock {
  color: #a6a6a6;
  padding: 10vw 0 12vw;
  text-align: center;
}

@{deep} .van-badge--fixed {
  right: 8px;
}

.avatar {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  border: 2px solid #fff;
}

.name-box {
  padding-top: 2vw;
  padding-left: 3vw;
  width: 100%;

  .title_flex {
    display: flex;
    justify-content: space-between;
    margin-top: 2px;
  }

  .nickName {
    font-size: 4.3vw;
    font-weight: bold;
    line-height: 16px;
  }

  .nameBoxLeft {
    flex: auto;
    width: 180px;
    // flex: 1;
  }

  .flexAutoR {
    flex: 1;
  }

  .ellipsisTextName {
    // max-width: 115px;
    max-width: 160px;
    // flex: 1;
    // // width: 150px;
    // word-break: break-all;
    // display: -webkit-box;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
  }

  .image_status {
    width: 6vw;
    height: 6vw;
    margin-right: 1vw;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .image_xs {
    width: 26px;
    margin-right: 4px;
    height: 16px;
  }

  .image_idCard {
    width: 15px;
    height: 12px;
    margin-right: 4.5px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.profile-info {
  background-image: linear-gradient(#fff, #f1f4f9);
  padding: 20px 10px;
}

.info {
  height: 17vw;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.van {
  &-icon {
    margin-bottom: 10px;
  }

  &-cell__value {
    font-size: 3.4vw;
  }
}

.vip-box {
  background-color: #3a3935;
  border-radius: 10px;
  display: flex;
  padding: 13px 30px;
  justify-content: space-between;
  align-items: center;
}

.vip-box .text {
  line-height: 18px;
  display: flex;
}

.top {
  margin-top: 6.4vw;
}

.asset {
  width: 25px;
  height: 27px;
  padding: 0 3vw;
}

.titleAsset {
  width: 32px;
  height: 32px;
  padding: 0 3vw;
  margin: 0 auto 2.66667vw;
}

.user {
  &-header {
    display: flex;
    padding: 6vh 3vw 1.6vh;
    border-bottom: 1px solid #f5f5f5;
  }

  &-status {
    display: flex;
    margin-top: 11px;
    font-size: 13px;
    align-items: center;
    justify-content: space-between;
  }

  &-myOrder {
    padding: 13px 15px 15px;
    display: flex;
    justify-content: space-between;
    font-size: 3.8vw;
    font-weight: bold;
  }

  &-Ordercell {
    padding: 0;
  }

  &-poster {
    width: 100%;
    display: block;
  }

  &-name {
    height: 60px;
    line-height: 60px;
    margin-left: 10px;
  }

  &-phone {
    position: absolute;
    left: 5vw;
    top: 40vw;
    display: flex;
  }

  &-phone label {
    font-size: 1em;
  }

  &-group {
    padding: 0 7px;
    margin: 0 10px 11px;
    border-radius: 10px;
    background-color: #fff;
  }

  &-lines {
    padding: 0 0 7vw;
    font-size: 3.2vw;
    text-align: center;

    .van-icon {
      display: block;
      font-size: 24px;

      .van-info {
        right: 18px;
      }
    }
  }

  &-links {
    padding: 4vw 0 5vw;
    font-size: 3.2vw;
    text-align: center;

    .Unbound {
      color: #828282;
      font-size: 2.7vw;
      margin-top: 0px;
    }

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }

  &-myClerk {
    padding-top: 2.13333vw;
    padding-bottom: 6.4vw;
    font-size: 3.2vw;
  }
}
</style>
